/**
 * Le niveau d'un attendu choisi HORS du niveau de la classe (2026-09-29,
 * demande de deux profs : évaluer une 4e sur un objectif de 6e). Rien dans le
 * cas courant ; « 6e » en gris quand l'attendu vient d'un autre niveau.
 */

const CLASSES_PASTILLE = 'flex-shrink-0 text-[10.5px] font-extrabold rounded-full px-2 py-0.5 bg-slate-200 text-slate-700';

/** '6eme' | '6' | '6ème A' → '6' ; sinon ''. */
export const chiffreNiveau = (niveau) => String(niveau ?? '').match(/[3-6]/)?.[0] || '';

/** L'attendu est-il d'un autre niveau que la classe ? (faux si l'un des deux est inconnu) */
export const horsNiveau = (attendu, niveauClasse) => {
    const n = chiffreNiveau(attendu?.niveau);
    const c = chiffreNiveau(niveauClasse);
    return Boolean(n && c && n !== c);
};

/**
 * Niveau (chiffre) d'une classe ou d'un groupe : le premier caractère de son
 * nom (« 4A », « 601 »), à défaut la classe d'origine d'un élève (groupe dont
 * le nom ne dit pas le niveau, « Groupe A »). '' si rien ne le dit.
 */
export const niveauDeLaClasse = (nom, eleves) => chiffreNiveau(String(nom || '').charAt(0))
    || chiffreNiveau(String(eleves?.[0]?.classe_nom || '').charAt(0));

const PastilleNiveau = ({ attendu, niveauClasse }) => (horsNiveau(attendu, niveauClasse) ? (
    <span className={CLASSES_PASTILLE}>
        {chiffreNiveau(attendu.niveau)}e
    </span>
) : null);

/**
 * Les niveaux, hors classe, des attendus réunis dans une carte de bilan
 * (attendu, notion ou thème ; `niveaux` : ['6eme'…]). Un thème au même nom
 * dans deux cycles (« Grandeurs et mesures ») peut réunir des attendus de 4e
 * et de 6e : « 6e » dit alors qu'il en contient.
 */
export const PastillesNiveaux = ({ niveaux, niveauClasse }) => {
    const c = chiffreNiveau(niveauClasse);
    if (!c) return null;
    const autres = [...new Set((niveaux || []).map(chiffreNiveau))]
        .filter((n) => n && n !== c)
        .sort((a, b) => b - a);
    return autres.map((n) => (
        <span key={n} title={`Contient des attendus de ${n}e`} className={CLASSES_PASTILLE}>
            {n}e
        </span>
    ));
};

export default PastilleNiveau;
